<div class="p-grid mu-loading" [ngClass]="{ show: showLoading }">
  <div
    class="p-col-12 mu-without-padding mu-loading-content"
    [ngClass]="{
      'mu-loading-content-for-input': type === 'input',
      'mu-loading-content-for-icon': type === 'icon',
      'mu-loading-content-for-table': type === 'table',
      'mu-loading-content-for-autocomplete': type === 'autocomplete'
    }"
  >
    <img src="assets/images/icons/icon-loading{{ type === 'icon' ? '-white' : '' }}.png" alt="" />
    <span *ngIf="title" class="mu-loading-title"> {{ title }} </span>
  </div>
</div>
